import $ from "jquery";
import fancybox from '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';

class Gallery {

    Init = () => {
        let check_width = false,
            img_width = 0,
            check_load = false;

        const ResizeTolls = function(){
            if($('.fancybox-content').length){
                $('.fancybox-toolbar').width(img_width);
            }
        };

        const SetWidth = function(){
            let content_w = $('.fancybox-content').width();
            if(content_w>0 && !check_width){
                img_width = content_w;
                $('.fancybox-toolbar').width(img_width).addClass('open');
                $(window).bind( "resize", ResizeTolls );
                check_width = true;
            }
        };

        const SetDef = function(){
            //img_width = 0;
            //check_width = false;
            //$(window).unbind( "resize", ResizeTolls );
            //$('.fancybox-toolbar').removeClass('open');
            check_load = false;
            $('.gallery__tolls').removeClass('open');
        };

        let autoPlay;

        $('[data-fancybox^="gallery"]').fancybox({
            buttons: [
                //"zoom",
                //"share",
                //"slideShow",
                //"fullScreen",
                //"download",
                //"thumbs",
                "arrowLeft",
                "arrowRight",
                "close",
            ],
            arrows: false,
            loop: true,
            keyboard: true,
            //smallBtn: "false",
            infobar: false,
            hash: false,
            clickContent: false,

            animationEffect: "zoom-in-out",
            animationDuration: 500,
            transitionEffect: "fade",
            transitionDuration: 2000,
            preventCaptionOverlap: true,

            hideScrollbar: true,

            touch:false,
            //touch: {
             //   vertical: false,
                //horizontal: false
                //momentum: true
            //},
            slideShow: {
                autoStart: true,
                speed: 2000
            },
            mobile: {
                touch: {
                       vertical: false,
                    //horizontal: false
                    //momentum: true
                },
            },
            init: function(){

            },
            /*
            caption : function( instance, item ) {
                var caption = $(this).data('caption') || '';

                if ( item.type === 'image' ) {
                    caption = '<div style="position: absolute;">'+caption+'</div>' ;
                }

                return caption;
            },*/
            beforeLoad: function() {
                if($('.fancybox-content').html() && !check_load){
                    ///check_load = true;
                    $('.gallery__tolls,.gallery__tolls__hide_arrow_left,.gallery__tolls__hide_arrow_right').remove();
                    let html = '<div class="gallery__tolls">' +
                        '<div class="gallery__tolls__left"><div class="gallery__tolls__arrows"><button class="gallery__tolls__arrows-l"></button><button class="gallery__tolls__arrows-r"></button></div> ' +
                        '<div class="gallery__tolls__caption">'+$('.fancybox-caption__body').text()+'</div></div>' +
                        '<button class="gallery__tolls__close"></button>' +
                        '</div>' +
                        '<a href="#" class="gallery__tolls__hide_arrow_left"></a>' +
                        '<a href="#" class="gallery__tolls__hide_arrow_right"></a>';
                    $('.fancybox-content').prepend(html);

                    $(".gallery__tolls__close").bind("click", function(){
                        $('.fancybox-button--close').click();
                    });
                    $(".gallery__tolls__arrows-l, .gallery__tolls__hide_arrow_left").bind("click", function(e){
                        e.preventDefault();
                        $('.fancybox-toolbar .fancybox-button--arrow_left').click();
                    });
                    $(".gallery__tolls__arrows-r, .gallery__tolls__hide_arrow_right").bind("click", function(e){
                        e.preventDefault();
                        $('.fancybox-toolbar .fancybox-button--arrow_right').click();
                    });

                }
            },
            afterLoad: function () {
                //SetWidth();
                $('.gallery__tolls').addClass('open');
                autoPlay = setTimeout(function () {
                    //$('.fancybox-toolbar .fancybox-button--arrow_right').click();
                },2000);

            },
            beforeShow: function(){
                //SetWidth();
            },
            afterShow: function () {
                //SetWidth();
            },

            beforeClose: function() {
                SetDef();
            },
            afterClose: function () {
            }
        });


    };

}

export default new Gallery;